import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DefaultButton from '../Button/DefaultButton';
import DetailWrapper from '../CardRow/DetailWrapper';
import { Title } from '../CustomizedComponents/Texts';
import ButtonWrapper from '../Button/ButtonWrapper';
import CustomTextField from '../CustomizedComponents/CustomTextField';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CustomSnackBar from '../CustomizedComponents/CustomSnackbar';
import useAppContext from '../../hooks/context/useAppContext';
import { useIntl } from 'react-intl';

const isAvailable = (object) => {
  return Object.values(object).every((item) => {
    return item !== null;
  });
};

const CustomerDetail = ({ customer, handlers }) => {
  const {
    id,
    name,
    idExternal,
    organizationNumber,
    kamIds,
    customersIds,
    city,
    street,
    zip,
    state,
    putData,
    putLoading,
    putError,
    postData,
    postError,
    postLoading,
    postStateData,
    postStateLoading,
    postStateError,
    usersEnum,
  } = customer;
  const { setName, setIdExternal, setOrganizationNumber, sendHandler, setKamIds, setCustomersIds, setStreet, setZip, setCity, sendCustomerState } = handlers;
  const history = useHistory();
  const intl = useIntl();

  const { handleSubmit, register, errors } = useForm();
  const [titleCustomer, setTitleCustomer] = useState(' ');
  const [open, setOpen] = useState(false);
  const success = intl.formatMessage({ id: 'app.action.saved' });
  const dataMissing = intl.formatMessage({ id: 'app.data.missing' });
  const dataIncorrect = intl.formatMessage({ id: 'app.data.incorrect' });
  const [message, setMessage] = useState(success);
  const [issues, setIssues] = useState(null);
  const organizationTitle = 'app.customer.organization';
  const crn = 'app.customer.crn';
  const sap = 'app.customer.sap';
  const cityTitle = 'app.customer.city';
  const streetTitle = 'app.customer.street';
  const zipTitle = 'app.customer.zip';
  const kamTitle = 'app.customer.kam';
  const representativeTitle = 'app.customer.representative';
  const save = 'app.buttons.save';
  const cancel = 'app.buttons.cancel';
  const active = 'app.buttons.active';
  const inactive = 'app.buttons.inactive';

  const { setBackNavigation } = useAppContext();

  useEffect(() => {
    name && setTitleCustomer(name);
    if (putError) {
      setMessage(putError?.data?.message);
      setIssues(putError?.data?.issues);
    } else if (postError) {
      setMessage(postError?.data?.message);
      setIssues(postError?.data?.issues);
    } else {
      setMessage(success);
      setIssues(null);
    }
    putData && setTitleCustomer(putData.name);
    postData && history.push(`/customers/${postData.id}`);
  }, [putError, postError, history, name, titleCustomer, putData, postData, success]);

  const handlerUser = (user) => {
    setCustomersIds(user.map((item) => item.id));
  };

  const handleClick = (idButton) => {
    if (idButton !== 'cancel') {
      setOpen(true);
      sendHandler();
      setBackNavigation('/customers');
    } else {
      history.push(`/`);
    }
  };

  useEffect(() => {
    if (postStateData && !postStateLoading && !postStateError && id !== 'new') {
      setMessage(success);
      setOpen(true);
    }
  }, [postStateData, postStateError, postStateLoading, success, id]);

  useEffect(() => {
    if (putData && !putLoading && !putError && id === 'new') {
      setMessage(success);
      setOpen(true);
    }
  }, [putData, putLoading, putError, success, id]);

  return (
    <>
      <DetailWrapper>
        <form onSubmit={handleSubmit(handleClick)}>
          <Title title={titleCustomer} />
          <CustomerDetailTextFields
            city={city}
            cityTitle={cityTitle}
            crn={crn}
            dataIncorrect={dataIncorrect}
            dataMissing={dataMissing}
            errors={errors}
            idExternal={idExternal}
            name={name}
            organizationTitle={organizationTitle}
            organizationNumber={organizationNumber}
            register={register}
            sap={sap}
            setCity={setCity}
            setIdExternal={setIdExternal}
            setName={setName}
            setOrganizationNumber={setOrganizationNumber}
            setStreet={setStreet}
            setZip={setZip}
            street={street}
            streetTitle={streetTitle}
            zip={zip}
            zipTitle={zipTitle}
          />
          <CustomTextField
            id={'7'}
            onChange={(event) => {
              setKamIds([event.target.value]);
            }}
            select
            title={kamTitle}
            value={kamIds}
            SelectProps={{
              native: true,
            }}
            variant="outlined">
            <option key={null} value={undefined}></option>
            {usersEnum
              ?.filter((user) => (user.role === 'KAM' || user.role === 'ASM') && user.state)
              .map((user) => (
                <option key={user.id} value={user.id}>
                  {`${user.firstname} ${user.surname} (${user.email})`}
                </option>
              ))}
          </CustomTextField>
          <Autocomplete
            multiple
            id={'8'}
            options={usersEnum?.filter((item) => (item.role === 'CUSTOMER' || item.role === 'CUSTOMER_VIEWER') && item.state)}
            onChange={(e, v) => handlerUser(v)}
            getOptionLabel={(user) => `${user.firstname} ${user.surname} (${user.email})`}
            value={usersEnum?.filter((user) => customersIds.indexOf(user.id) !== -1)}
            renderInput={(params) => <CustomTextField {...params} variant="outlined" title={representativeTitle} />}
          />
          <ButtonWrapper>
            <DefaultButton
              primary={false}
              id={'cancel'}
              title={cancel}
              onClick={(event) => {
                handleClick(event.currentTarget.id);
              }}
            />
            {id !== 'new' && (
              <DefaultButton
                onClick={sendCustomerState}
                primary={false}
                title={!postStateLoading && state === 1 ? inactive : active}
                loaders={[postStateLoading]}
              />
            )}
            <DefaultButton primary={true} type="submit" title={save} loaders={[postLoading, putLoading]} />
          </ButtonWrapper>
          {isAvailable({ postLoading, putLoading }) && message && (
            <CustomSnackBar status={putError || postError ? 'error' : 'success'} message={message} setOpen={setOpen} open={open} />
          )}
          {isAvailable({ postLoading, putLoading }) &&
            issues &&
            issues.map((issue) => <CustomSnackBar key={issue} status={'error'} message={issue} setOpen={setOpen} open={open} />)}
        </form>
      </DetailWrapper>
    </>
  );
};
CustomerDetail.propTypes = {
  customer: PropTypes.object,
  handlers: PropTypes.object,
};

export default CustomerDetail;

const CustomerDetailTextFields = ({
  crn,
  name,
  idExternal,
  organizationNumber,
  sap,
  organizationTitle,
  setName,
  setOrganizationNumber,
  setIdExternal,
  setCity,
  register,
  dataMissing,
  dataIncorrect,
  cityTitle,
  city,
  setStreet,
  streetTitle,
  street,
  setZip,
  zipTitle,
  zip,
  errors,
}) => {
  const fields = [
    {
      id: '1',
      name: 'name',
      onChange: (event) => {
        setName(event.target.value);
      },
      title: organizationTitle,
      value: name || '',
      variant: 'outlined',
      inputRef: register({
        required: dataMissing,
      }),
      helperText: errors?.name?.message,
      error: !!errors?.name,
    },
    {
      id: '2',
      name: 'organizationNumber',
      onChange: (event) => {
        setOrganizationNumber(event.target.value);
      },
      title: crn,
      value: organizationNumber || '',
      variant: 'outlined',
      inputRef: register({
        required: dataMissing,
        pattern: {
          value: /^[0-9]*$/,
          message: dataIncorrect,
        },
      }),
      helperText: errors?.organizationNumber?.message,
      error: !!errors?.organizationNumber,
    },
    {
      id: '3',
      name: 'idExternal',
      onChange: (event) => {
        setIdExternal(event.target.value);
      },
      title: sap,
      value: idExternal || '',
      variant: 'outlined',
      inputRef: register({
        required: dataMissing,
      }),
      helperText: errors?.idExternal?.message,
      error: !!errors?.idExternal,
    },
    {
      id: '4',
      name: 'city',
      onChange: (event) => {
        setCity(event.target.value);
      },
      title: cityTitle,
      value: city || '',
      variant: 'outlined',
      inputRef: register({
        required: dataMissing,
      }),
      helperText: errors?.city?.message,
      error: !!errors?.city,
    },
    {
      id: '5',
      name: 'street',
      onChange: (event) => {
        setStreet(event.target.value);
      },
      title: streetTitle,
      value: street || '',
      variant: 'outlined',
      inputRef: register({
        required: dataMissing,
      }),
      helperText: errors?.street?.message,
      error: !!errors?.street,
    },
    {
      id: '6',
      name: 'zip',
      onChange: (event) => {
        setZip(event.target.value);
      },
      title: zipTitle,
      value: zip || '',
      variant: 'outlined',
      inputRef: register({
        required: dataMissing,
      }),
      helperText: errors?.zip?.message,
      error: !!errors?.zip,
    },
  ];

  return (
    <>
      {fields.map((field) => (
        <CustomTextField key={field.id} {...field} />
      ))}
    </>
  );
};

CustomerDetailTextFields.propTypes = {
  crn: PropTypes.string,
  name: PropTypes.string,
  idExternal: PropTypes.string,
  organization: PropTypes.string,
  organizationNumber: PropTypes.string,
  sap: PropTypes.string,
  setName: PropTypes.func,
  setOrganizationNumber: PropTypes.func,
  setIdExternal: PropTypes.func,
  setCity: PropTypes.func,
  register: PropTypes.func,
  dataMissing: PropTypes.string,
  dataIncorrect: PropTypes.string,
  cityTitle: PropTypes.string,
  city: PropTypes.string,
  setStreet: PropTypes.func,
  streetTitle: PropTypes.string,
  street: PropTypes.string,
  setZip: PropTypes.func,
  zipTitle: PropTypes.string,
  zip: PropTypes.string,
  organizationTitle: PropTypes.string,
  errors: PropTypes.any,
};
